"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOneToMovieInfoModel = (data) => {
    return {
        title: data.Title,
        movieId: data.MovieId,
        edis: data.Edis,
        rating: data.Rating,
        ratingCount: data.RatingCount,
        poster: data.Poster,
        link: data.link
    };
};
exports.convertMultiToMovieInfoModel = (data) => {
    return data.map(d => {
        return {
            title: d.Title,
            movieId: d.MovieId,
            edis: d.Edis,
            rating: d.Rating,
            ratingCount: d.RatingCount,
            poster: d.Poster,
            link: d.link
        };
    });
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/converters/movieInfoConverter.ts